import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e0d3040"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "disks-member-expir-reminder"
}
const _hoisted_2 = {
  key: 1,
  class: "disks-member-low-cloud-space"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 云备份空间不足，内置磁盘新增内容将不再做备份。您可通过清理内置磁盘已备份的内容，来释放云备份空间。 ", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]



export default /*#__PURE__*/_defineComponent({
  props: {
    isMembershipExpired: { type: Boolean },
    isvip: { type: Boolean },
    lastVipDay: null,
    handleToPaySVip: null
  },
  setup(__props: any) {


  

return (_ctx: any,_cache: any) => {
  return (__props.isMembershipExpired)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, " 您的会员" + _toDisplayString(__props.lastVipDay > 0 ? `将于${__props.lastVipDay}天后到期` : '已到期') + "，云备份空间数据将为您保留30天时长，请尽快续费盒子会员。 ", 1),
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.handleToPaySVip && __props.handleToPaySVip(...args)))
        }, _toDisplayString(__props.isvip ? '立即续费' : '立即开通'), 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
}
}

})